export default {
  ANONYMOUS_TICKET_REPOSITORY: Symbol.for('ANONYMOUS_TICKET_REPOSITORY'),
  CREATE_ANONYMOUS_TICKET_COMMAND: Symbol.for('CREATE_ANONYMOUS_TICKET_COMMAND'),
};
